// extracted by mini-css-extract-plugin
export default {"container":"notification_link_content-module__container--1H7dy"};